import { useEffect, useMemo } from 'react'

const CSS_VAR_MAP = {
  colorPrimary: '--proposal-primary',
  colorAccent: '--proposal-accent',
  colorGold: '--proposal-gold',
  colorBackground: '--proposal-bg',
  colorText: '--proposal-text',
  colorMuted: '--proposal-muted',
  fontDisplay: '--proposal-font-display',
  fontBody: '--proposal-font-body'
}

const DEFAULT_THEME = {
  colorPrimary: '#1b3a5c',
  colorAccent: '#2ea3f2',
  colorGold: '#d4a84b',
  colorBackground: '#f7f8fa',
  colorText: '#333333',
  colorMuted: '#666666',
  fontDisplay: 'Cormorant Garamond',
  fontBody: 'DM Sans',
  logoUrl: '',
  logoWidth: 180
}

export default function useTheme (templateTheme) {
  const theme = useMemo(() => ({
    ...DEFAULT_THEME,
    ...(templateTheme || {})
  }), [templateTheme])

  // Load Google Fonts dynamically
  useEffect(() => {
    const fonts = [theme.fontDisplay, theme.fontBody].filter(Boolean)
    if (fonts.length === 0) return

    const families = fonts.map(f => f.replace(/ /g, '+')).join('&family=')
    const linkId = 'proposal-google-fonts'
    let link = document.getElementById(linkId)

    if (link) {
      link.href = `https://fonts.googleapis.com/css2?family=${families}:wght@300;400;500;600;700&display=swap`
    } else {
      link = document.createElement('link')
      link.id = linkId
      link.rel = 'stylesheet'
      link.href = `https://fonts.googleapis.com/css2?family=${families}:wght@300;400;500;600;700&display=swap`
      document.head.appendChild(link)
    }

    return () => {
      const el = document.getElementById(linkId)
      if (el) el.remove()
    }
  }, [theme.fontDisplay, theme.fontBody])

  useEffect(() => {
    const root = document.documentElement
    Object.entries(CSS_VAR_MAP).forEach(([key, cssVar]) => {
      if (theme[key]) {
        const value = key.startsWith('font')
          ? `'${theme[key]}', ${key === 'fontDisplay' ? 'Georgia, serif' : "'Segoe UI', sans-serif"}`
          : theme[key]
        root.style.setProperty(cssVar, value)
      }
    })

    return () => {
      Object.values(CSS_VAR_MAP).forEach(cssVar => {
        root.style.removeProperty(cssVar)
      })
    }
  }, [theme])

  return theme
}
